const hexColorRegex = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

export function hexToRgb(hex: string): [number, number, number] {
  if (!hexColorRegex.test(hex)) {
    return [0, 0, 0];
  }

  const formatted = hex.replace("#", "");

  return [
    formatted.slice(0, 2),
    formatted.slice(2, 4),
    formatted.slice(4, 6),
  ].map((part) => parseInt(part, 16)) as [number, number, number];
}

function calcColorDistance(
  hexColorLeft: string,
  hexColorRight: string
): number {
  const [redLeft, greenLeft, blueLeft] = hexToRgb(hexColorLeft);
  const [redRight, greenRight, blueRight] = hexToRgb(hexColorRight);

  return Math.sqrt(
    Math.pow(redRight - redLeft, 2) +
      Math.pow(greenRight - greenLeft, 2) +
      Math.pow(blueRight - blueLeft, 2)
  );
}

export function getClosestColor(customColor: string, list: string[]) {
  const mapped: [string, number][] = list.map((hex) => [
    hex,
    calcColorDistance(hex, customColor),
  ]);

  return mapped.reduce<{ color: string; distance: number }>(
    (acc, [hex, distance]) =>
      distance < acc.distance ? { color: hex, distance } : acc,
    {
      color: "",
      distance: Infinity,
    }
  );
}
